<mat-card class='no-shadow bg--lighter-gray border-single'>
  <mat-card-content>
    <a class='no-underline text--body-text' [href]='ticketAttachment.attachment_url' target='_blank'>
      <div class='text--sm'>{{ ticketAttachment.name }}</div>
      <div class='text--sm'>{{ ticketAttachment.size / 1000 }}kb</div>
    </a>
  </mat-card-content>
</mat-card>
